import { Avatar, ListItem, ListItemText } from '@mui/material';

interface IProps {
  image: string;
  title: string;
}

export const PopUpUser = ({ title, image }: IProps) => {
  return (
    <ListItem id="pop-up-user-component__components-menu-burger__listitem__l10" style={{ gap: 10, padding: '16px' }}>
      <Avatar id="pop-up-user-component__components-menu-burger__avatar__l11" sx={{ width: 25, height: 25 }} alt={title} src={image} />
      <ListItemText id="pop-up-user-component__components-menu-burger__listitemtext__l12"> {title}</ListItemText>
    </ListItem>);

};